import React from "react";
import { Baby, Clock, Sparkles, HeartHandshake, ArrowRight } from "lucide-react";
import { CATEGORIES } from "../mock";
import { useJobModal } from "../context/JobModalContext";

const ICONS = { Baby, Clock, Sparkles, HeartHandshake };

export default function Categories() {
  const { openJobModal } = useJobModal();
  return (
    <section id="families" className="bg-white">
      <div className="max-w-7xl mx-auto px-5 py-16">
        <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] text-center">Find the right help</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {CATEGORIES.map((c) => {
            const Icon = ICONS[c.icon];
            return (
              <button
                type="button"
                key={c.id}
                onClick={() => openJobModal({ service: c.id })}
                className="group text-left rounded-2xl border border-black/[0.08] p-7 transition-all hover:border-[#7c2233]/30 hover:shadow-[0_18px_40px_-24px_rgba(124,34,51,0.35)] hover:-translate-y-0.5"
              >
                <div className="w-12 h-12 rounded-xl bg-[#f7e4e6] flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#7c2233]" strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-xl text-[#1f1a1b] mt-4">{c.title}</h3>
                <p className="text-[15px] text-[#5a5254] mt-2 leading-relaxed">{c.text}</p>
                <span className="inline-flex items-center gap-1.5 text-[14px] font-medium text-[#7c2233] mt-4">
                  Post a {c.title.toLowerCase().replace(/s$/, "")} job <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
